import { usePageTitle } from "../hooks/usePageTitle";

// Shared layout for the legal/contact pages (Privacy, Terms, Cancellation, Contact) -
// keeps typography consistent without repeating inline styles per heading/paragraph
// across four long-form pages. See .legal-content rules in styles/tokens.css.
export default function LegalLayout({ title, updated, children }) {
  usePageTitle(title);
  return (
    <section style={{ maxWidth: 720, margin: "0 auto", padding: "3rem 20px 4rem" }}>
      <h1
        style={{
          fontFamily: "var(--font-voice)",
          fontSize: "clamp(26px, 4vw, 34px)",
          color: "var(--navy)",
          margin: "0 0 8px",
          lineHeight: 1.25,
        }}
      >
        {title}
      </h1>
      {updated && <p style={{ fontSize: 13, color: "var(--text-muted)", margin: "0 0 32px" }}>Last updated: {updated}</p>}
      <div className="legal-content">{children}</div>
    </section>
  );
}
